export default "__VITE_ASSET__BtLdGYkV__"